/*
export const AuthApi = "http://190.210.128.64:27017/api/";
export const UrlApi = "http://190.210.128.64:27020/api";
//export const UrlApi = "http://localhost:27020/api";
export const MailApi = "http://190.210.128.78:3535"
export const titulonavbar = "DevExt"
*/


export const titulonavbar = "Producción"
export const AuthApi = "https://prodauthapi.netizar.com/api/";
export const UrlApi = "https://prodapi.netizar.com/api";
export const MailApi = "https://uservices.netizar.com";


